/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevPriceRowDto
 */
export interface DevPriceRowDto {
    /**
     * 
     * @type {number}
     * @memberof DevPriceRowDto
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof DevPriceRowDto
     */
    isProcessed: boolean;
    /**
     * 
     * @type {number}
     * @memberof DevPriceRowDto
     */
    year: number;
    /**
     * 
     * @type {number}
     * @memberof DevPriceRowDto
     */
    priceUnitId: number;
    /**
     * 
     * @type {number}
     * @memberof DevPriceRowDto
     */
    productId: number;
    /**
     * 
     * @type {number}
     * @memberof DevPriceRowDto
     */
    lp: number;
    /**
     * 
     * @type {number}
     * @memberof DevPriceRowDto
     */
    rrp: number;
    /**
     * 
     * @type {Date}
     * @memberof DevPriceRowDto
     */
    validFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof DevPriceRowDto
     */
    validTo: Date;
    /**
     * 
     * @type {Date}
     * @memberof DevPriceRowDto
     */
    updatedAt: Date | null;
}

/**
 * Check if a given object implements the DevPriceRowDto interface.
 */
export function instanceOfDevPriceRowDto(value: object): value is DevPriceRowDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('isProcessed' in value) || value['isProcessed'] === undefined) return false;
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('priceUnitId' in value) || value['priceUnitId'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('lp' in value) || value['lp'] === undefined) return false;
    if (!('rrp' in value) || value['rrp'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    if (!('validTo' in value) || value['validTo'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function DevPriceRowDtoFromJSON(json: any): DevPriceRowDto {
    return DevPriceRowDtoFromJSONTyped(json, false);
}

export function DevPriceRowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevPriceRowDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isProcessed': json['isProcessed'],
        'year': json['year'],
        'priceUnitId': json['priceUnitId'],
        'productId': json['productId'],
        'lp': json['lp'],
        'rrp': json['rrp'],
        'validFrom': (new Date(json['validFrom'])),
        'validTo': (new Date(json['validTo'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}

export function DevPriceRowDtoToJSON(json: any): DevPriceRowDto {
    return DevPriceRowDtoToJSONTyped(json, false);
}

export function DevPriceRowDtoToJSONTyped(value?: DevPriceRowDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isProcessed': value['isProcessed'],
        'year': value['year'],
        'priceUnitId': value['priceUnitId'],
        'productId': value['productId'],
        'lp': value['lp'],
        'rrp': value['rrp'],
        'validFrom': (formatDateOnly(value['validFrom'])),
        'validTo': (formatDateOnly(value['validTo'])),
        'updatedAt': (value['updatedAt'] == null ? null : (value['updatedAt'] as any).toISOString()),
    };
}

